<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入" :mask-closable="false" width="530" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">操作步骤：</p>
        <template v-if="pageType == 'config'">
          <p class="text2">1、在本菜单列表搜索出需要导入或更新费率的产品。</p>
          <p class="text2" v-if="data.nodeType == 1">2、点击【导出当前组织的费率】或直接全量【导出产品库费率】。</p>
          <p class="text2" v-if="data.nodeType == 2">2、点击【导出当前组织的费率】。</p>
          <p class="text2">3、填写或修改费率。</p>
          <p class="text2">4、导入费率Excel至当前组织。</p>
        </template>
        <template v-if="pageType == 'template'">
          <p class="text2">1、在本菜单列表搜索出需要导入或更新费率的产品。</p>
          <p class="text2" v-if="data.nodeType == 1">2、点击【导出模板内产品费率】或直接全量【导出产品库费率】。</p>
          <p class="text2" v-if="data.nodeType == 2">2、点击【导出模板内产品费率】。</p>
          <p class="text2">3、填写或修改费率。</p>
          <p class="text2">4、导入费率Excel至当前模板。</p>
        </template>
        <p class="text2">
          提示：导出后尽量只修改费用部分，否则可能导致产品和费用方案无法识别。每次导入只新增或更新表里对应方案的费用，不在导入表里的产品费用系统不做删除处理，如需删除产品请手动删除。单次导入最多2000条。
        </p>
      </div>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="download()" ghost v-if="pageType == 'config'">导出当前组织的费率</Button>
        <Button type="primary" @click="download()" ghost v-if="pageType == 'template'">导出模板内产品费率</Button>
        <Button type="primary" @click="downloadLibrary()" v-if="data.nodeType == 1" ghost>导出产品库费率</Button>
        <Upload
          ref="upload"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :data="data.uploadParams"
          :before-upload="handleBeforeUpload"
          action="/"
        >
          <Button type="primary" :loading="loading"><i class="iconfont icondaochu" v-if="!loading"></i>导入费率</Button>
        </Upload>
      </div>
    </Modal>
    <!-- 导入进度 -->
    <progress-modal ref="progressModal" @success="$emit('success')"></progress-modal>
  </div>
</template>
<script>
import progressModal from './progressModal';
export default {
  components: { progressModal },
  props: {
    pageType: null
  },
  data() {
    return {
      columns: [
        {
          title: '行号',
          key: 'row',
          width: 100,
          align: 'center'
        },
        {
          title: '错误原因',
          key: 'content',
          align: 'center',
          minWidth: 100
        }
      ],
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      visible: false,
      loading: false,
      data: {}
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    // 初始化，获取进行中任务
    getProgress(showBig = false) {
      this.$refs.progressModal.open(showBig);
    },
    open(data = {}) {
      this.data = data;
      this.loading = false;
      this.visible = true;
    },
    // 导出页面费率
    download() {
      this.$units.downloadFile(this.data.downloadUrl, this.data.downloadParams, 'POST');
    },
    // 导出产品库费率
    downloadLibrary() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const url = '/buz/commission/config/export';
      const parasm = {
        nodeType: 1,
        id: userInfo.organId,
        dataLock: true,
        handleSource: 1
      };
      this.$units.downloadFile(url, parasm, 'POST');
    },
    handleBeforeUpload(file) {
      const format = file.name.split('.')[1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      const params = this.data.daochuParams;
      if (params) {
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            formData.append(key, element);
          }
        }
      }
      this.loading = true;
      this.$http({
        type: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: this.data.uploadUrl,
        data: formData,
        apiPermissionCode: this.data.apiPermissionCode
      })
        .then(res => {
          this.visible = false;
          this.getProgress(true);
        })
        .finally(() => {
          this.loading = false;
        });

      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
